import { Box, Button, Grid, Stack, Typography } from '@mui/material'
import moment from 'moment'
import React, {
  createContext,
  useContext,
  useEffect,
  useMemo,
  useState,
} from 'react'
import DateRangeSelector from '../../../../../components/DateTime/DateRangeSelector'
import { FileDownload } from '@mui/icons-material'
import OverviewCards from './OverviewCards'
import Filters from './Filters'
import { GlobalContext } from '../../../../../App'
import OvertimeClaimsResults from './Results'
import API from '../../../../../services/API'
import SelectedShiftDrawer from './SelectedShiftDrawer'
import OlderClaims from './OlderClaimsBanner'
import { useLocation } from 'react-router-dom'

export const OvertimeClaimContext = createContext({})

const OvertimeClaims = () => {
  const { baseLocationOptions } = useContext(GlobalContext)
  const [loading, setLoading] = useState(true)
  const [loadingMore, setLoadingMore] = useState(false)
  const [fetchError, setFetchError] = useState(false)
  const [filter, setFilter] = useState({
    startDate: moment().subtract(1, 'month').startOf('month'),
    endDate: moment().endOf('day'),
    baseLocations: [],
    tab: 'Pending',
    employee: null,
  })
  const [results, setResults] = useState([])
  const [counts, setCounts] = useState({
    Pending: 0,
    Approved: 0,
    Rejected: 0,
    'All Claims': 0,
  })
  const [oldestClaim, setOldestClaim] = useState(null)
  const [selectedShift, setSelectedShift] = useState(null)
  const [passedShiftIDused, setPassedShiftIDused] = useState(false)

  const loadClaims = () => {
    setOldestClaim(null)
    API.post('/overtime-claims-get', {
      ...filter,
      assignedTo: filter?.employee?.employee?._id ?? null,
      startDate: filter.startDate.toDate(),
      endDate: filter.endDate.toDate(),
    })
      .then((res) => {
        if (res.status === 200) {
          setResults(res.data.results)
          setCounts(res.data.counts)
          if (res.data?.oldestMatchingClaim) {
            setOldestClaim(res.data.oldestMatchingClaim)
          }
        }
      })
      .finally(() => setLoading(false))
  }

  const loadMoreClaims = () => {
    setLoadingMore(true)
    API.post('/overtime-claims-get', {
      ...filter,
      assignedTo: filter?.employee?.employee?._id ?? null,
      startDate: filter.startDate.toDate(),
      endDate: filter.endDate.toDate(),
      skip: results.length,
    })
      .then((res) => {
        if (res.status === 200) {
          setResults((prev) => [...prev, ...res.data.results])
          setCounts(res.data.counts)
        }
      })
      .finally(() => setLoadingMore(false))
  }

  function useQuery() {
    const { search } = useLocation()
    return useMemo(() => new URLSearchParams(search), [search])
  }
  const query = useQuery()
  const passedShiftID = query.get('shift')

  useEffect(() => {
    setLoading(true)
    if (passedShiftID && !passedShiftIDused) {
      API.get(`/overtime/shift-info/${passedShiftID}`)
        .then((res) => {
          if (res.status === 200) {
            setSelectedShift(res.data)
            setFilter((prev) => ({
              ...prev,
              startDate: moment(res.data.start),
              endDate: moment(res.data.end),
            }))
            setPassedShiftIDused(true)
          }
        })
        .then(() => {
          loadClaims()
        })
    } else {
      loadClaims()
    }
  }, [filter])

  return (
    <OvertimeClaimContext.Provider
      value={{
        filter,
        setFilter,
        loading,
        counts,
        results,
        selectedShift,
        setSelectedShift,
        loadClaims,
        loadMoreClaims,
        loadingMore,
      }}
    >
      <Stack gap={2}>
        <Stack direction={{ xs: 'column', lg: 'row' }} gap={{ xs: 1, lg: 2 }}>
          <Stack flex={1}>
            <Typography variant="title2">Overtime Claims</Typography>
            <Typography variant="body2">
              Review and manage overtime claims submitted by staff
            </Typography>
          </Stack>
          {/* <Button
            variant="outlined"
            startIcon={<FileDownload />}
            sx={{
              borderRadius: 2,
              px: 2,
              py: 1,
              justifyContent: 'space-between',
            }}
          >
            Export
          </Button> */}
        </Stack>
        {/* <OverviewCards /> */}
        <Filters filter={filter} setFilter={setFilter} />
        <OlderClaims
          oldestClaim={oldestClaim}
          setOldestClaim={setOldestClaim}
        />
        <OvertimeClaimsResults />
        <SelectedShiftDrawer />
      </Stack>
    </OvertimeClaimContext.Provider>
  )
}

export default OvertimeClaims
